<template>
    <main-layout>

        <app-header icon="tools">
            Interventions
        </app-header>

        <action-bar :back="{name: 'home'}">
            <router-link class="btn add btn-full" id="main-action" to="new-fibsdd">
                <i class="icon-add"></i>
                <strong>Nouvelle</strong> intervention
            </router-link>
        </action-bar>

        <filter-bar @searchBarChanged="updateSearch" placeholderFilter="Rechercher par Numéro ou raison Sociale">
        </filter-bar>

        <div id="list-interventions" class="list" v-if="filterList">
            <fibsdd-item
                v-for="fi in filterList"
                :key="fi.id"
                :fibsdd="fi"
                :detenteur="detenteurs[fi.detenteur]"
                :installation="installations[fi.installation]"
                :idUser="idUser"
            />
        </div>

    </main-layout>
</template>

<script>
import FibsddItem from './FibsddItem.vue'
import Fibsdd from '../../../js/models/Fibsdd'
import Detenteur from '../../../js/models/Detenteur'
import Installation from '../../../js/models/Installation'
import User from "../../../js/models/User";

export default {
        data() {
            return {
                filterList: [],
                detenteurs: {},
                installations: {},
                interventions: [],
                strSearch: '',
                idUser: null
            }
        },
        computed: {

        },
        methods: {
            updateSearch(str) {
                this.filterList = this.interventions;
                this.strSearch = String(str[0]).toLowerCase()
                this.filterList = this.filterList.filter(fi => {

                    let check = false;
                    let search = this.strSearch;


                    if (_.has(fi, 'detenteurString') && fi.detenteurString !== ""){
                        if (fi.detenteurString.toLowerCase().includes(search)) { check = true }
                    }

                    if (_.has(fi, 'numero') && null !== fi.numero) {
                        if( fi.numero.toLowerCase().includes(search)){check = true}
                    }

                    if (_.has(fi, 'ordre_travail') && fi.ordre_travail != null && fi.ordre_travail.toLowerCase().includes(search)) {
                        check = true
                    }

                    if (!_.has(fi, 'ordre_travail') && !_.has(fi, 'numero')  ){
                        check = true
                    }

                    if(check === true) {
                        return fi;
                    }


                }).reverse();


            }
        },
        async mounted() {

            this.idUser = (await User.getUserInfo()).id;

            let fi = new Fibsdd;
            let tempList = [];

            tempList = await fi.getList();
            tempList = tempList.filter(fi => {
                return fi.cloture !== true;
            })



            tempList.sort((a, b) => {
                if (a.affectation_user === this.idUser && b.affectation_user !== this.idUser) {
                    return -1;
                }
                if (b.affectation_user === this.idUser && a.affectation_user !== this.idUser) {
                    return 1;
                }

                // Sinon, tri par id DESC
                return b.id - a.id;
            });

            this.interventions = tempList;

            // Extraire les IDs uniques pour detenteur et installation
            const detenteurIds = [...new Set(tempList.map(fi => fi.detenteur))];
            const installationIds = [...new Set(tempList.map(fi => fi.installation))];

            // Charger toutes les detenteurs
            const detenteurPromises = detenteurIds.map(id => Detenteur.getDetenteur(id));
            const detenteursData = await Promise.all(detenteurPromises);
            detenteursData.forEach(det => {
                this.$set(this.detenteurs, det.id, det);
            });

            // Charger toutes les installations
            const installationPromises = installationIds.map(id => Installation.getInstallation(id));
            const installationsData = await Promise.all(installationPromises);
            installationsData.forEach(install => {
                this.$set(this.installations, install.id, install);
            });

            // Déterminer la supprimabilité
            const supprimablePromises = tempList.map(fi => Fibsdd.isInitied(fi.id));
            const supprimableResults = await Promise.all(supprimablePromises);
            tempList.forEach((fi, index) => {
                fi.supprimable = supprimableResults[index];
            });

            this.filterList = tempList;
        },
        components: {
            FibsddItem
        }
    }

</script>

<style>
    #list-interventions .list-item {
        display: block;
        position: relative;
        background-color: #eee;
        padding: 10px;
        padding-right: 50px;
        margin-bottom: 10px;
        text-transform: uppercase;
        text-decoration: none;
    }

    #list-interventions .list-item strong {
        color: #000000;
        font-size: 2.3rem;
        font-weight: 700;
    }

    #list-interventions .list-item span.detenteur {
        color: #999999;
        font-size: 1.5rem;
        font-weight: 400;
    }

    #list-interventions .list-item span.install {
        color: #333333;
        font-size: 1.5rem;
        font-weight: 700;
    }

    #list-interventions .list-item:after {
        content: '\e909';
        font-family: 'fi360' !important;
        speak: none;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        font-size: 3.3rem;
        position: absolute;
        right: 10px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        color: #5698d2;
    }
</style>



// WEBPACK FOOTER //
// ListeFibsdd.vue?263a0b9a